/** I1b notice detector (spec 2026-07-09-campaigns-c1-vodafone-port-design.md §3).
 * Model-side ACTUAL rows carry no attribution dims, so a dim filter silently drops
 * them while Fitted (yhat) survives. Fires ONLY when the Actual axis was explicitly
 * requested — a view where actual rows never exist (e.g. Contribution channels,
 * media contributions) must stay silent. */
export const MODEL_DIM = 'Model'
export const MODEL_ACTUAL = 'actual'

export interface ActualAxisDropInput {
  rows: ReadonlyArray<{ dims: Record<string, string | null> | null }>
  filterDims: Record<string, string[]>
  groupBy?: readonly string[] | string | null
}

/** Returns the non-Model dims doing the filtering when the explicitly-requested
 * Actual axis came back empty; null = no notice. */
export function detectActualAxisDrop(input: ActualAxisDropInput): string[] | null {
  const groups = typeof input.groupBy === 'string' ? [input.groupBy] : (input.groupBy ?? [])
  const modelFilter = input.filterDims[MODEL_DIM] ?? []
  const actualRequested = modelFilter.includes(MODEL_ACTUAL) || groups.includes(MODEL_DIM)
  if (!actualRequested) return null
  if (input.rows.length === 0) return null
  if (input.rows.some((r) => r.dims?.[MODEL_DIM] === MODEL_ACTUAL)) return null
  const activeDims = Object.keys(input.filterDims).filter(
    (d) => d !== MODEL_DIM && (input.filterDims[d]?.length ?? 0) > 0,
  )
  return activeDims.length > 0 ? activeDims : null
}
